export type CreateDossierResponseDTO = {
  dossier: string;
};

export type CreateDossierRequestBodyDTO = {
  idRichiesta: string;
  firmatario: {
    tipo: SignatureType;
    tipoAutenticazione: AuthType | null;
    telefono: string;
    email: string;
  };
};

export type SendDossierResponseDTO = {
  success: boolean;
  message: string;
  data: string;
  errors: string[];
  errorCode: string;
  timestamp: string;
  path: string;
};

export type SendDossierRequestBodyDTO = {
  idRichiesta: string;
};

export type GetCheckSignStatusDTO = {
  message: string;
};

export enum SignatureType {
  DRIVER_A = "CONDUCENTE_A",
  DIRVER_B = "CONDUCENTE_B",
}

export enum AuthType {
  SPID = "SPID",
  CIE = "CIE",
  SELFID = "SELFID",
}
